import type { FunctionComponent } from "react";

import Button, { type WeightIconType } from "./button";

interface EmailButtonProps {
  buttonSize?: "sm" | "lg" | "base";
  buttonType: "primary" | "secondary" | "tertiary";
  color: "white" | "lime" | "indigo";
  weightIcon?: WeightIconType;
  email: string;
  label?: string;
  className?: string;
  leftIcon?: FunctionComponent<{
    size?: number | string;
    mirrored: boolean;
    weight: WeightIconType;
    className?: string;
  }>;
}

const EmailButton = ({
  buttonSize,
  buttonType,
  color,
  email,
  label,
  className,
  leftIcon,
  weightIcon,
}: EmailButtonProps) => {
  return (
    <Button
      buttonType={buttonType}
      size={buttonSize}
      color={color}
      leftIcon={leftIcon}
      onClick={() => window.open(`mailto:${email}`, "_self")}
      label={label}
      className={className}
      weightIcon={weightIcon}
    />
  );
};
export default EmailButton;
